<template>
  <div>
    <div v-if="this.$store.state.loader">
      <div class="loader-box">
        <div class="loadingio-spinner-rolling">
          <div class="ldio">
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="this.$store.state.customModal"
      class="loader-box policy-modal-box"
    >
      <div
        class="
          max-w-[1140px]
          mx-auto
          shadow-0-2-5
          text-center
          p-15
          relative
          top-1/2
          -translate-y-1/2
          bg-white
          z-[99]
        "
      >
        <div class="ldio">
          <div></div>
        </div>
        <div class="text-2xl font-medium mb-9 mt-7">
          <span class="modal-text-1" style="transition: opacity 500ms">

          </span>
        </div>
        <div class="mb-12 text-lg text-black text-opacity-60">
          Nie zamykaj ani nie odświeżaj tego okna przeglądarki
        </div>
        <img
          src="@/assets/img/punkta_comparer/image-loader.png"
          class="inline-block"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      video: "",
    };
  },
  mounted() {
    this.video = this.chooseVideo();
  },
  methods: {
    chooseVideo() {
      var year = new Date().getFullYear();
      if (
        this.$moment(new Date()).isSameOrAfter(year + "-03-21", "day") &&
        this.$moment(new Date()).isSameOrBefore(year + "-11-30", "day")
      ) {
        if (window.matchMedia("(min-width: 767px)").matches) {
          return "/app/themes/punkta/assets/videos/Punkta_lato_clear.mov";
        } else {
          return "/app/themes/punkta/assets/videos/Punkta_lato_mobile.mov";
        }
      } else {
        if (window.matchMedia("(min-width: 767px)").matches) {
          return "/app/themes/punkta/assets/videos/Punkta_zima_clear.mov";
        } else {
          return "/app/themes/punkta/assets/videos/Punkta_zima_mobile.mov";
        }
      }
    }
  },
};
</script>
<style type="text/css">
@keyframes ldio {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.ldio div {
  position: absolute;
  width: 102px;
  height: 102px;
  border: 6px solid var(--primary-color);
  border-top-color: transparent;
  border-radius: 50%;
}
.ldio div {
  animation: ldio 1s linear infinite;
  top: 100px;
  left: 100px;
}

.policy-modal-box .ldio div {
  left: 40px;
  width: 80px;
  height: 80px;
  top: 40px;
  position: relative;
  margin: 0 auto;
}
.loadingio-spinner-rolling {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: none;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
}
.loadingio-spinner-rolling .ldio {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.loadingio-spinner-rolling .ldio div {
  box-sizing: content-box;
}
/* generated by https://loading.io/ */
</style>
